import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldAppearance, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-date-range-picker',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './date-range-picker.component.html',
  styleUrl: './date-range-picker.component.scss',
})
export class DateRangePickerComponent {
  @Input({ required: true }) formGroup!: FormGroup;
  @Input() label = 'Periodo';
  @Input() startControlName = 'start';
  @Input() endControlName = 'end';
  @Input() startPlaceholder = 'Desde';
  @Input() endPlaceholder = 'Hasta';
  @Input() appearance: MatFormFieldAppearance = 'fill';
}
